import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {
  ApartmentDetailPageContentComponent
} from "../../../components/apartment-detail-page-content/apartment-detail-page-content.component";
import {AsyncPipe} from "@angular/common";
import {map, switchMap} from "rxjs";
import {validatedNotNull} from "../../../utils";
import {ActivatedRoute, RouterLink} from "@angular/router";
import {ApartmentService} from "../../../services/apartment.service";
import {initialSignupRoute, initialSignupRouteIncludingInfo} from "../../signup/specific-signup.routes";
import {
  ApartmentDetailInfoItemComponent
} from "../../apartments-tab/apartment-detail-page/apartment-detail-info-item/apartment-detail-info-item.component";
import {RegularEligibleUnitsComponent} from "../../../components/apartment-detail-page-content/eligible-units-component/regular-eligible-units.component";
import {SeniorEligibleUnitsComponent} from "../../../components/apartment-detail-page-content/eligible-units-component/senior-eligible-units.component";
import {toSignal} from "@angular/core/rxjs-interop";
import {LotteriesAndFooterComponent} from "../../../components/lotteries-and-footer/lotteries-and-footer.component";
import {ButtonDirective} from "primeng/button";
import {Divider} from "primeng/divider";

@Component({
  selector: 'homey-public-apartment-detail-page',
  imports: [
    ApartmentDetailPageContentComponent,
    AsyncPipe,
    ApartmentDetailInfoItemComponent,
    RegularEligibleUnitsComponent,
    SeniorEligibleUnitsComponent,
    RouterLink,
    LotteriesAndFooterComponent,
    ButtonDirective,
    Divider
  ],
  templateUrl: './public-apartment-detail-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PublicApartmentDetailPageComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly apartmentService = inject(ApartmentService);

  public readonly apartment$ =
    this.route.paramMap.pipe(
      map(params => validatedNotNull(params.get('lotteryId'))),
      switchMap(apartmentId => this.apartmentService.getApartment(apartmentId))
    );

  private readonly currentApp = toSignal(this.apartment$);
  protected readonly otherApartments =
    computed(() => (this.apartmentService.openLotteries() ?? []).filter(
      lottery => lottery.borough === this.currentApp()?.borough && lottery.id !== this.currentApp()?.id
    ))

  protected readonly initialSignupRoute = initialSignupRoute;
  protected readonly initialSignupRouteIncludingInfo = initialSignupRouteIncludingInfo;
}
